module.exports = __webpack_public_path__ + "static/FMlogo-4722f0fe3bd0904a7552387de4715f2f.png";